import React, { useEffect } from "react";
import useModal from "@/base/hooks/useModal";
import { PaperFormEmbed } from "@/components/elements/PaperFormEmbed";
import * as styles from "./styles.module.scss";
import Icon from "@/components/elements/Icon";

interface Props {
  paperFormId: string;
}

const FeedbackModal = ({ paperFormId }: Props) => {
  const { isOpen, toggleModal } = useModal();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        toggleModal();
      }
    };

    if (isOpen) {
      document.body.classList.add(styles.noScroll);
      window.addEventListener("keydown", handleKeyDown);
    } else {
      document.body.classList.remove(styles.noScroll);
      window.removeEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.body.classList.remove(styles.noScroll);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, toggleModal]);

  return (
    <div className={styles.feedbackModalWrapper}>
      <button onClick={toggleModal} className={styles.feedbackButton}>
        Share your feedback
      </button>

      {isOpen && (
        <div
          className={styles.modal}
          role="dialog"
          aria-modal="true"
          tabIndex={-1}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              toggleModal();
            }
          }}
        >
          <div className={styles.modalContent}>
            <button className={styles.close} onClick={toggleModal}>
              <Icon name="close-x" />
            </button>
            <PaperFormEmbed paperFormId={paperFormId} />
          </div>
        </div>
      )}
    </div>
  );
};

export default FeedbackModal;